module.exports = __webpack_public_path__ + "static/media/battery-image-02.40ea7895.png";